// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__x_zWa","col":"Table_col__2-h3N","fulfillmentStatus":"Table_fulfillmentStatus__mDPb-","emailCol":"Table_emailCol__1mtYo"};